import { Line, mixins } from 'vue-chartjs'
import kit from '../../tools/kit'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  data: () => ({
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      },
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            let obj = data.datasets[0].data[tooltipItem.index]
            return kit.str.fmtCurrency(obj.y, 2, obj.currency)
          }
        }
      }
    }
  }),
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
